import { createAction, props } from '@ngrx/store';
import { PaymentType } from 'src/app/core/enums/enums';
import { CreditCard, PaymentForm, ReissueRequestStatus } from 'src/app/core/models/reissue.model';
import { ExchangeQuoteRequest } from 'src/app/core/models/voluntary-change.model';

export const AutomaticBooking = createAction(
  '[Reissue] Automatic Booking',
  props<{ paymentType: PaymentType; formData: CreditCard; isPaymentFirst: boolean }>()
);

export const AutomaticBookingSuccess = createAction(
  '[Reissue] Automatic Booking success',
  props<{ formOfPayment: PaymentForm; quote: ExchangeQuoteRequest; isPaymentFirst: boolean }>()
);

export const AutomaticBookingFail = createAction(
  '[Reissue] Automatic Booking fail',
  props<{ requestStatus: ReissueRequestStatus }>()
);

export const ManualBooking = createAction(
  '[Reissue] Call Manual Booking',
  props<{ paymentType: PaymentType; formData: CreditCard; isPaymentFirst: boolean }>()
);

export const ManualBookingSuccess = createAction(
  '[Reissue] Manual Booking success',
  props<{ formOfPayment: PaymentForm; quote: ExchangeQuoteRequest; isPaymentFirst: boolean }>()
);

export const ManualBookingFail = createAction(
  '[Reissue / Booking] Manual Booking fail',
  props<{ requestStatus: ReissueRequestStatus }>()
);
